import React, { useState, useEffect, Suspense } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router} from 'react-router-dom';
import { withCookies } from 'react-cookie';
import { withStyles } from '@material-ui/core/styles';
import ReactGA from 'react-ga4';
import './App.scss';

import { getUser } from 'examsbook-react-sdk/actions/getUser';
import { getMainExamsList } from 'examsbook-react-sdk/actions/getCategory';
import { getAppSettings } from "examsbook-react-sdk/actions/getAppSettings";
import Navigation from "./components/Navigation/Navigation";
import HeaderWrapper from "./components/common/Header/Header";
import { useScreenWidth } from "examsbook-react-sdk/custom-hooks";
import ScrollToTop from "./components/Navigation/ScrollToTop";
import NotFoundPage from "./components/common/Errors/NotFoundPage";

function initializeReactGA() {
    ReactGA.initialize('G-DWET6RS3P9');
}

initializeReactGA();

/**
 * Main Application component.
 * @returns {*}
 * @constructor
 */
function App() {
    const [ openSidebar, setOpenSidebar ] = useState(false);
    const appSettings = useSelector((state) => state.appSettings);
    const user = useSelector(state => state.user);
    const windowScreenWidth = useScreenWidth();
    const dispatch = useDispatch();
    const screenWidth = 900;

    useEffect(() => {
        setOpenSidebar(windowScreenWidth > screenWidth);
    }, [ windowScreenWidth ]);

    //Fetch basic info.
    useEffect(() => {
        dispatch(getUser());
        dispatch(getMainExamsList());
        dispatch(getAppSettings());
    }, [ dispatch ]);

    //effect to check for user.
    useEffect(() => {
        if (!user || !user.loggedIn) {
            window.location.href = '/log-in?return_to=/my-app';
            return;
        }
    }, [ user ]);

    function openDrawer(e) {
        setOpenSidebar(!openSidebar);
        e.preventDefault();

    }

    function closeDrawer() {
        setOpenSidebar(false);
    }

    const paymentEnabled = !!appSettings.paymentEnabled;
    return (
        <div className="App">
            <Router>
            {/* <Suspense fallback={<div>Loading...</div>}> */}
                <HeaderWrapper
                    open={openSidebar}
                    handleDrawerOpen={openDrawer}
                    handleDrawerClose={closeDrawer}
                />
                <ScrollToTop />
                <div className={'container ' + (openSidebar ? 'open-drawer' : '')}
                     onClick={windowScreenWidth <= screenWidth ? closeDrawer.bind(this) : () => null}>
                    <Navigation paymentEnabled={paymentEnabled}/>
                </div>
            {/* </Suspense> */}
            {/* <Suspense fallback={<div>Loading...</div>}>
                <NotFoundPage component={NotFoundPage}/>
            </Suspense>  */}
            </Router>
        </div>
    );
}

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing(1) * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '16px 32px',
        outline: 'none',
    },
});

export default withCookies(withStyles(styles)(App));
